import { posts } from "aleph-js";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

const PublishForm = (props) => {
  const [postContent, setPostContent] = useState("");
  const [txInProgress, setTxInProgress] = useState(false);

  useEffect(() => {
    if (props.modalOpen) {
      setTxInProgress(false);
    }
  }, [props.modalOpen]);

  const handleTyping = (e) => {
    setPostContent(e.target.value);
  };

  const disconnect = (e) => {
    e.preventDefault();
    props.setModalOpen(false);
  };
  const submitPost = async (e) => {
    e.preventDefault();

    setTxInProgress(true);

    posts
      .submit(
        props.alephAccount.address,
        "chat",
        { body: postContent },
        {
          account: props.alephAccount,
          channel: "TEST",
          api_server: "https://api2.aleph.im",
          ref: "hall",
        }
      )
      .catch((error) => {
        setTxInProgress(false);
      });
  };

  return (
    <Modal show={props.modalOpen}>
      <Modal.Header className="py-0">
        <a href="#" onClick={disconnect}>
          ×
        </a>
      </Modal.Header>

      {txInProgress ? (
        <Modal.Body>
          <div className="progress">
            <div
              className="progress-bar"
              role="progressbar"
              style={{ width: "25%" }}
              aria-valuenow="25"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </Modal.Body>
      ) : (
        <div>
          <Modal.Body>
            <textarea
              onChange={handleTyping}
              className="form-control"
              placeholder="What's happening?"
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-primary"
              onClick={submitPost}
            >
              Post
            </button>
          </Modal.Footer>
        </div>
      )}
    </Modal>
  );
};
export default PublishForm;
